import React, { useState, useMemo, useEffect } from "react";
import {
    Autocomplete,
    Box,
    TextField,
    Typography,
    Stack,
    IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { Priority } from "hooks/usePriorities";
import { getTranslation } from "common/utilities";
import { useTranslations } from "hooks";

interface PriorityMenuProps {
    allPriorities: Priority[];
    currentPriorityName: string | null;
    onPriorityChange: (newPriority: Priority) => void;
    isEditing: boolean;
    onEditClick: () => void;
    loading?: boolean;
    onCancel?: () => void;
}

const PriorityMenu: React.FC<PriorityMenuProps> = ({
    allPriorities,
    currentPriorityName,
    onPriorityChange,
    isEditing,
    onEditClick,
    loading,
    onCancel,
}) => {
    const translations = useTranslations();
    const [open, setOpen] = useState(false);

    // const currentValue = useMemo(() => {
    //     return allPriorities.find(p => p.name === currentPriorityName) || null;
    // }, [currentPriorityName, allPriorities]);

    useEffect(() => {
        if (isEditing) {
            setOpen(true);
        }
    }, [isEditing]);

    if (!isEditing) {
        return (
            <Stack direction="row" alignItems="center" spacing={1}>
                <Typography variant="body2">
                    {currentPriorityName || "N/A"}
                </Typography>
                <IconButton
                    id="edit-priority-btn"
                    size="small"
                    onClick={(e) => {
                        e.stopPropagation();
                        onEditClick();
                    }}
                    sx={{ p: 0.5 }}
                >
                    <EditIcon fontSize="small" />
                </IconButton>
            </Stack>
        );
    }

    return (
        <Box onClick={(e) => e.stopPropagation()}>
            <Autocomplete
                open={open}
                onOpen={() => setOpen(true)}

                onClose={(event, reason) => {
                    setOpen(false);
                    if (reason !== 'selectOption') {
                        onCancel?.();
                    }
                }}
                value={null}
                onChange={(e, newValue) => {
                    e.stopPropagation();
                    if (newValue) {
                        onPriorityChange(newValue);
                    } else {
                        onCancel?.();
                    }
                }}
                options={allPriorities}
                getOptionLabel={(option) => String(option.name)}
                isOptionEqualToValue={(option, value) => option.id === value?.id}
                size="small"
                sx={{ minWidth: 150 }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        autoFocus
                        size="small"
                        placeholder={getTranslation(translations, "generic.priorities.caption")}
                    />
                )}
            />
        </Box>
    );
};

export default PriorityMenu;
